import { Box, Stack, Typography } from "@mui/material";

function SummaryStat({ label, value }) {
  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 180,
        p: 1.5,
        border: "1px solid #ddd",
        borderRadius: 1,
        backgroundColor: "#fff",
      }}
    >
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography sx={{ fontWeight: 700, fontSize: "1.05rem" }}>{value}</Typography>
    </Box>
  );
}

export default function StreetTeamSummary({ stats = [] }) {
  if (!stats.length) {
    return null;
  }

  return (
    <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} useFlexGap flexWrap="wrap">
      {stats.map((stat) => (
        <SummaryStat key={stat.label} label={stat.label} value={stat.value} />
      ))}
    </Stack>
  );
}
